<template>
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">                
                <el-date-picker v-model="start_time" value-format="yyyy-MM" class="search_time_input" type="month" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM"  class="search_time_input" type="month" placeholder="结束日期"></el-date-picker>
            </div>
            <!-- <div class="search_time search_inputBox">                
                <el-date-picker v-model="start_time" type="month" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" type="month" placeholder="开始日期"></el-date-picker>
            </div> -->
            <el-select class="search_select search_inputBox" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库名称" @visible-change="getInventoryBalanceList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.warehouse_type" multiple collapse-tags placeholder="仓库类型" @visible-change="getInventoryBalanceList('warehouse_type')">
                <el-option v-for="list in selectMapC.warehouse_type" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="resetSearch">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" v-if="module.includes(',warehouse-balance-export,')" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <!-- v-if="module.indexOf(',sell-report-statistic-return,')!=-1" -->
            <!-- <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.includes(',warehouse-balance-fee,')" @click="openStorageFee">生成仓储费用</el-button> -->
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="stock.balance.month.list" :isLoading="tableLoading" @getRow="getRow" @rowClick="rowClick" @dialogViewClick="dialogViewClick" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalName">入库件数： {{totalObj.in_number}}</div>
            <div class="totalName">入库方数： {{totalObj.in_cube}}m³</div>
            <div class="totalName">出库件数： {{totalObj.out_number}}</div>
            <div class="totalName">出库方数： {{totalObj.out_cube}}m³</div>
            <div class="totalName">仓储费金额： {{totalObj.amount}}元</div>
            <div class="totalName">选中结存件数：{{selectNumber}}</div>
            <div class="totalName">选中结存方数： {{selectCube}}m³</div>
            <!-- <div class="totalNumber">入库件数: <span :style="totalObj.number_diff>0?'color: #5bcca1':'color: red'"> {{totalObj.number_diff}}</span></div> -->
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
    
    <!-- 字段过滤 START -->
    <filter-fields :tableData="filter" scene="stock.balance.month.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
    <!-- 字段过滤 END -->
    <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogLine" :modal="false" title="添加仓储费用" custom-class="full_dialog">
        <div class="dialogSearchBox">
            <el-form class="clearfix dialogFormB"  :model="storageForm" :rules="addDialogRules" ref="storageForm">
                <el-form-item  label="仓库名称：" prop="warehouse_id">
                    <el-select v-model="storageForm.warehouse_id" @visible-change="getSelectList('warehouse')" @change="changeWarehouse">
                        <el-option v-for="(list,index) in selectMap.warehouse" :key="index" :value="list.id" :label="list.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="开始日期：" prop="start_time">
                    <el-date-picker v-model="storageForm.start_time" value-format="yyyy-MM-dd" type="date" placeholder="开始日期" @change="changeWarehouse"></el-date-picker>
                </el-form-item>
                <el-form-item  label="结束日期：" prop="end_time">
                    <el-date-picker v-model="storageForm.end_time" value-format="yyyy-MM-dd" type="date" placeholder="结束日期" @change="changeWarehouse"></el-date-picker>
                </el-form-item>
                <el-form-item  label="结存方数：" prop="container_no">
                    <el-input v-model="storageForm.cube" disabled></el-input>
                </el-form-item>
                <el-form-item  label="合计金额：" prop="container_no">
                    <el-input v-model="storageForm.amount" disabled></el-input>
                </el-form-item>
                <el-form-item  label="收款单位：" prop="container_no">
                    <el-input v-model="storageForm.payee" disabled></el-input>
                </el-form-item>
                <el-form-item  label="备注：" prop="container_no">
                    <el-input v-model="storageForm.remark"></el-input>
                </el-form-item>
                <div class="elFormBoxBtnListCol">
                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addStorageFee">确认</el-button>
                </div>
            </el-form>
        </div>
    </el-dialog>
    </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                params:{
                    start_time_m:'',
                    end_time_m:'',
                    warehouse_id:[],
                    warehouse_type:[],
                    per_page: 50,
                    page:1
                },
                start_time:"",
                end_time:"",
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    user:[],
                    warehouse:[]
                },
                selectMapC:{
                    warehouse_id:[],
                    warehouse_type:[],
                },
                // dialog
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                totalObj:{},
                tableCol:[	
                    {colName:"结存月份",colKey:"stock_date",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓库名称",colKey:"warehouse",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"仓库类型",colKey:"warehouse_type_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库件数",colKey:"in_number",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库方数",colKey:"in_cube",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"出库件数",colKey:"out_number",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"出库方数",colKey:"out_cube",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"结存件数",colKey:"stock_number",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"结存方数",colKey:"stock_cube",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true,isColor:true},
                    {colName:"元/m³/天",colKey:"warehouse_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"仓储费金额",colKey:"amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"费用状态",colKey:"status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"费用单号",colKey:"remark",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                warehouseList:[],
                creatorList:[],
                checkerList:[],
                dialogVisible:false,
                storageForm:{
                    warehouse_id:'',
                    start_time:'',
                    end_time:'',
                    cube:"",
                    amount:"",
                    payee:'',
                    remark:"",
                },
                addDialogRules:{
                    warehouse_id: [{ required: true, message: '不能为空', trigger: 'change' }],
                    start_time: [{ required: true, message: '不能为空', trigger: 'change' }],
                    end_time: [{ required: true, message: '不能为空', trigger: 'change' }],
                },
                selectRow:[],
                selectCube:0.0000,//选中方数
                selectNumber:0,//选中件数
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            getInventoryBalanceList(target){
                this.$getInventoryBalanceList(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            excelExport(){
                this.$exportExecl("/erp/stock.balance.export","库存月结余",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectsaleCostSeeList(target){
                this.$getSelectsaleCostSeeList(target,this.params).then(res=>{
                    this.selectMapS[res.data.data.target]=res.data.data.result;
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time_m = this.start_time;
                this.params.end_time_m = this.end_time;
                this.tableLoading = true;
                this.$postColumnList("/erp/stock.balance.month.list",this.params,res=>{
                    this.pl(res)
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj = res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        if(item.process_status==1){
                            item.isDialogViewrecorda=true;
                        }else{
                             item.isDialogViewrecordb=true;
                        }
                        // if(item.stock_date!=0){
                        //     this.list[index].stock_date = this.formatTime(item.stock_date+"000")
                        // }else{
                        //     this.list[index].stock_date = "";
                        // }
                        if(item.check_id){
                            item.check_id = '查看详情'
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name=='stock_cube'){
                    //结余库存明细
                    if(obj.row.stock_balance_id!=0){
                        sessionStorage.setItem("stock_balance_ID",obj.row.stock_balance_id);
                        this.$root.$children[0].$children[0].addTab({
                            name: '月结存明细'+obj.row.stock_balance_id,
                            label: '月结存明细',
                            content: 'boardBalanceDetail'
                        });
                    }else{
                        this.tip('暂无结存明细',"warning")
                    }
                }else if(obj.name=='in_cube'){
                    //结余入库明细
                    sessionStorage.setItem("warehouse_ID",obj.row.warehouse_id);
                    sessionStorage.setItem("monthData",obj.row.stock_date);
                    this.$root.$children[0].$children[0].addTab({
                        name: '月结存入库明细'+obj.row.stock_date+obj.row.warehouse_id,
                        label: '月结存入库明细',
                        content: 'boardWarehousingInDetail'
                    });
                }else if(obj.name=='out_cube'){
                    //结余出库明细
                    sessionStorage.setItem("warehouse_ID",obj.row.warehouse_id);
                    sessionStorage.setItem("monthData",obj.row.stock_date);
                    this.$root.$children[0].$children[0].addTab({
                        name: '月结存出库明细'+obj.row.stock_date+obj.row.warehouse_id,
                        label: '月结存出库明细',
                        content: 'boardWarehousingOutDetail'
                    });
                }
            },
            //点击仓储费用
            openStorageFee(){
                this.dialogVisible = true;
            },
            changeWarehouse(){
                let obj = {};
                obj.start_time = this.formatTimeZero(this.storageForm.start_time);
                obj.end_time = this.formatTimeZero(this.storageForm.end_time);
                obj.warehouse_id = this.storageForm.warehouse_id;
                this.postFunc("/erp/stock.warehouse.date",obj,res=>{
                    this.storageForm.start_time = res.data.data.start_time?this.formatTime(res.data.data.start_time+"000"):''
                    this.storageForm.end_time = res.data.data.end_time?this.formatTime(res.data.data.end_time+"000"):''
                    this.storageForm.cube = res.data.data.cube;
                    this.storageForm.amount = res.data.data.amount;
                    this.storageForm.payee = res.data.data.payee;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addStorageFee(){
                let obj = {};
                obj.start_time = this.formatTimeZero(this.storageForm.start_time);
                obj.end_time = this.formatTimeZero(this.storageForm.end_time);
                obj.warehouse_id = this.storageForm.warehouse_id;
                obj.cube = this.storageForm.cube;
                obj.amount = this.storageForm.amount;
                obj.payee = this.storageForm.payee;
                obj.remark = this.storageForm.remark;
                this.postFunc("/erp/stock.warehouse.fee.add",obj,res=>{
                    this.tip('添加成功','success');
                    this.dialogVisible = false;
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            dialogViewClick(row){
                this.note_remark=row.row.process_remark;
                this.note_remark_id = row.row.id;
                this.noteVisible = true;
            },
            noteChangeSure(){
                this.postFunc('/erp/inventory.check.log.remark',{id:this.note_remark_id,remark:this.note_remark},res=>{
                    this.noteVisible = false;
                    this.getList();
                })
            },
            outnoteVisible(){
                this.noteVisible = false;
            },
            resetSearch(){
                this.params = this.params = {
                    start_time_m:"",
                    end_time_m:"",
                    warehouse_id:[],
                    warehouse_type:[],
                    per_page: 50,
                    page:1
                }
                this.start_time = "";
                this.end_time = "";
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
                let number = 0;
                let setNumber =0;
                this.selectRow.forEach(item=>{
                    number += Number(item.stock_cube)
                    setNumber += Number(item.stock_number)
                })
                this.selectCube = this.keepLimit(number);
                this.selectNumber = setNumber;
            },
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.storageForm = {
                        warehouse_id:'',
                        start_time:'',
                        end_time:'',
                        cube:"",
                        amount:"",
                        payee:'',
                        remark:"",
                    }
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
